import { z } from 'zod'

export const MIN_AUTO_TOP_UP_AMOUNT = 5
export const MAX_AUTO_TOP_UP_AMOUNT = 999

export const billingAutoTopUpFormSchema = z.object({
  threshold: z.coerce
    .number()
    .min(MIN_AUTO_TOP_UP_AMOUNT, `Threshold must be at least $${MIN_AUTO_TOP_UP_AMOUNT}`)
    .max(MAX_AUTO_TOP_UP_AMOUNT, `Threshold cannot exceed $${MAX_AUTO_TOP_UP_AMOUNT}`),
  topUpAmount: z.coerce
    .number()
    .min(MIN_AUTO_TOP_UP_AMOUNT, `Top-up amount must be at least $${MIN_AUTO_TOP_UP_AMOUNT}`)
    .max(MAX_AUTO_TOP_UP_AMOUNT, `Top-up amount cannot exceed $${MAX_AUTO_TOP_UP_AMOUNT}`),
})

export type BillingAutoTopUpFormSchemaType = z.infer<typeof billingAutoTopUpFormSchema>

export const defaultAutoTopUpFormValues: BillingAutoTopUpFormSchemaType = {
  threshold: MIN_AUTO_TOP_UP_AMOUNT,
  topUpAmount: 50,
}
